module.exports = __webpack_public_path__ + "img/20200219224053531.5a57e84e.jpg";